import { shadows }  from "./foundations/shadows"
import dark from "./dark"


export default {
  ...dark,
  colors: {
    readable: {
      normal: '#1E2026',
      primary: '#294AE0',
      masked: '#76808F',
      disabled: '#AEB4BC',
      placeholder: '#AEB4BC',
    },

    bg: {
      normal: '#FFFFFF',
      masked: '#F5F5F5',
  
      tooltip: {
        normal: '#FFFFFF',
        accent: '#F5F5F5',
        outer: '#0B0E11',
      },
  
      input: {
        normal: '#F5F5F5',
      },
    },

    text: {
      normal: "#1E2026",
      primary: "#294AE0",
      masked: "#76808F",
      disabled: "#AEB4BC",
      placeholder: "#AEB4BC",
    },

    scene: {
      border: '#E6E8EA',
  
      primary: {
        normal: '#294AE0',
        active: '#3257FF',
      },
    
      secondary: {
        normal: '#F5F5F5',
        active: '#3257FF',
      },
    
      success: {
        normal: '#02C076',
        active: '#2ED191',
      },
      
      danger: {
        normal: '#D9304E',
        active: '#FC6E75',
      },
    
      warning: {
        normal: '#F0B90B',
        active: '#F8D12F',
      },
    
      purple: {
        normal: '#9B00FB',
        active: '#B845FF',
      },
    },
  },

  shadows: {
    ...shadows,
    normal: '0px 2px 8px rgba(11, 14, 17, 0.16)',
    box: {
      normal: '0px 0px 16px rgba(11, 14, 17, 0.08)',
      increased: '0px 0px 16px rgba(11, 14, 17, 0.04)',
    },
  },
}